import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import ConversationAPI from "../../../api/api/ConversationAPI";
import { DefaultFields } from "../../../types/GlobalInterfaces";

export type Conversation = DefaultFields & {
  ContextID: string;
  Participants: string[];
} & {
  Context: "Record";
  RecordName: string;
  RecordModule: string;
};

export default function useConversations(query: Record<string, any>) {
  const tenantID = useAtomValue(tenantIDAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const conversations = useQuery({
    queryKey: ["conversations", tenantID, query],
    queryFn: () =>
      ConversationAPI.searchConversations(query).then(
        (data) => data.data.data.conversations
      ),
    enabled: queriesEnabled,
  });

  return {
    conversations: (conversations.data?.data || []) as Conversation[],
    pagination: conversations.data?.pagination ?? null,
    conversationsLoading: conversations.isLoading,
  };
}
